// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"30f67d91e62195045500","655":"9507974abc13aca1d224"}[chunkId] + ".js";
};